module.exports = __webpack_public_path__ + "img/clock-green.b53217ae.svg";